import { RJSFSchema } from '@rjsf/utils';

export const TEMPLATE_BODY_HTML_FIELD = 'template_body_html';

export type HtmlBodyFieldMode = 'default' | 'inline' | 'external';

const hasHtmlBodyField = (schema?: RJSFSchema): boolean => {
  const properties = (schema as { properties?: Record<string, unknown> })?.properties;
  return !!properties?.[TEMPLATE_BODY_HTML_FIELD];
};

/** Drop deferred HTML body from required when the designer owns that field. */
export function relaxExternalHtmlBodySchema(schema: RJSFSchema): RJSFSchema {
  const required = schema.required;
  if (!Array.isArray(required) || !required.includes(TEMPLATE_BODY_HTML_FIELD)) {
    return schema;
  }

  const nextRequired = required.filter((key) => key !== TEMPLATE_BODY_HTML_FIELD);
  return {
    ...schema,
    required: nextRequired,
  };
}

export function enhanceFlowStepUiSchema(
  uiSchema: Record<string, unknown>,
  htmlBodyFieldMode: HtmlBodyFieldMode = 'default',
  schema?: RJSFSchema
): Record<string, unknown> {
  if (htmlBodyFieldMode === 'default' || !hasHtmlBodyField(schema)) {
    return uiSchema;
  }

  const fieldUi = uiSchema[TEMPLATE_BODY_HTML_FIELD] as Record<string, unknown> | undefined;

  if (htmlBodyFieldMode === 'external') {
    return {
      ...uiSchema,
      [TEMPLATE_BODY_HTML_FIELD]: {
        ...fieldUi,
        'ui:widget': 'hidden',
      },
    };
  }

  return {
    ...uiSchema,
    [TEMPLATE_BODY_HTML_FIELD]: {
      ...fieldUi,
      'ui:widget': 'TipTapEditor',
    },
  };
}

export function enhanceFlowStepForHtmlBodyMode(
  uiSchema: Record<string, unknown>,
  schema: RJSFSchema | undefined,
  htmlBodyFieldMode: HtmlBodyFieldMode = 'default'
): { uiSchema: Record<string, unknown>; schema: RJSFSchema | undefined } {
  const nextUiSchema = enhanceFlowStepUiSchema(uiSchema, htmlBodyFieldMode, schema);

  if (htmlBodyFieldMode !== 'external' || !schema || !hasHtmlBodyField(schema)) {
    return { uiSchema: nextUiSchema, schema };
  }

  return {
    uiSchema: nextUiSchema,
    schema: relaxExternalHtmlBodySchema(schema),
  };
}
